import { render, staticRenderFns } from "./SubTitle.vue?vue&type=template&id=46a6f2f6&scoped=true"
import script from "./SubTitle.vue?vue&type=script&lang=js"
export * from "./SubTitle.vue?vue&type=script&lang=js"
import style0 from "./SubTitle.vue?vue&type=style&index=0&id=46a6f2f6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a6f2f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46a6f2f6')) {
      api.createRecord('46a6f2f6', component.options)
    } else {
      api.reload('46a6f2f6', component.options)
    }
    module.hot.accept("./SubTitle.vue?vue&type=template&id=46a6f2f6&scoped=true", function () {
      api.rerender('46a6f2f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/SubTitle.vue"
export default component.exports